import { Errors } from '@enauka/shared/infrastructure/error-handling';
import { FormularzFormly } from '@enauka/shared/ui/formly';
import { Component, OnInit } from '@angular/core';
import { ZeszytOnlineService } from '../../zeszyt-online.service';
import { FormGroup } from '@angular/forms';
import { CaptchaDto, PowerFormularzFrom } from '@enauka/api-strona-glowna';
import { FormlyFormOptions } from '@ngx-formly/core';

@Component({
  selector: 'enauka-formularz-kontaktowy',
  templateUrl: './formularz-kontaktowy.component.html',
  styleUrls: ['./formularz-kontaktowy.component.css']
})
export class FormularzKontaktowyComponent implements OnInit {
  submittedFailure = false;
  form: FormularzFormly<PowerFormularzFrom>;
  options: FormlyFormOptions = {};
  captcha: CaptchaDto;
  brakCaptcha: boolean;
  showSendingAlert: boolean;
  errorMessage: any;
  showSuccesAlert: boolean;

  constructor(private zeszytOnlineService: ZeszytOnlineService) {
  }

  ngOnInit(): void {
    this.getCaptcha();

    this.form = {
      model: {},
      form: new FormGroup({}),
      fields: [
        {
          key: 'zglaszajacy',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Zgłaszający',
            placeholder: 'Nazwa i adres zgłaszającego organu bądź uczelni oraz osoba upoważniona do kontaktu',
            required: true
          }
        },
        {
          key: 'telefon',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Telefon',
            placeholder: 'Podaj numer telefonu',
            required: false
          }
        },
        {
          key: 'email',
          type: 'input',
          templateOptions: {
            type: 'email',
            label: 'Adres e-mail',
            placeholder: 'Podaj adres e-mail',
            required: true
          }
        },
        {
          key: 'wiadomosc',
          type: 'textarea',
          templateOptions: {
            type: 'textarea',
            label: 'Wiadomość',
            placeholder: 'Napisz wiadomość',
            required: true
          }
        },
        {
          key: 'zgoda',
          type: 'checkbox',
          templateOptions: {
            label: 'Zgadzam się na przetwarzanie moich danych do celów obsłużenia przesłanej wiadomości',
            required: true
          }
        }
      ]
    }

  }

  showError() {
    return this.form.form.invalid && this.submittedFailure === true;
  };



  getCaptcha() {
    this.zeszytOnlineService.getCaptcha().subscribe((captcha) => {
      this.captcha = captcha;
    });
  }

  submit() {
    if (!this.captcha.odpowiedz) {
      this.brakCaptcha = true;
      return;
    } else {
      this.brakCaptcha = false;
    }
    if (this.form.form.valid) {
      this.showSendingAlert = true;
      const form = { ... this.form.model, captcha: this.captcha };
      this.zeszytOnlineService.wyslijFormularzKontaktowy(form).subscribe((res) => {
        this.showSuccesAlert = true;
        this.showSendingAlert = false;
        this.errorMessage = null;
        this.reset();
      }, (err) => {
        this.showSendingAlert = false;
        this.errorMessage = Errors.getMessage(err);
      });
      this.submittedFailure = false;
    } else {
      this.submittedFailure = true;
    }
  }

  reset() {
    this.options.resetModel();
    this.getCaptcha();
  }

}
